import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  spacing = theme.spacing,
  text = theme.text;
export var title = /*#__PURE__*/css(["margin:0;color:var(--neutral-black-base);font-weight:", ";", ";"], fonts.PRIMARY_SEMIBOLD.weight, fontSize(text.HEADING.XS));
export var intro = /*#__PURE__*/css(["", ";font-weight:", ";margin:", " 0;"], fontSize(text.BODY.MD), fonts.PRIMARY_REGULAR.weight, pxToRem(spacing.md));
export var container = /*#__PURE__*/css(["padding:", " 0;&:first-of-type{border-bottom:1px solid var(--neutral-black-30);}", ";"], pxToRem(spacing.xxl), mediaQuery({
  min: minBreakpoints.M
}, css(["&:first-of-type{border-bottom:0 none;}"])));